// TODO: esto debe estar compartido con la API
export const updatableColumns = [
  "aliases",
  "boxAccount",
  "oneDriveAccount",
  "googleDriveAccount",
  "dropboxAccount",
  "tags",
  "approvalGroups",
] as const;

export const columns = ["email", ...updatableColumns] as const;

export type UpdateableColumn = (typeof updatableColumns)[number];
export type Column = (typeof columns)[number];
